import  ByButton  from "./ByButton.vue"
import  SvgIcon  from "./SvgIcon.vue"
import  ByRadio  from "./ByRadio.vue"

export default {
    install(Vue){
        Vue.component('by-button',ByButton)
        Vue.component('svg-icon',SvgIcon)
        Vue.component('ByRadio',ByRadio)
    }
}


// WEBPACK FOOTER //
// ./src/components/public/index.js